var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"linear-gradient(to right, #FFAF7B, #D76D77, #3A1C71)","/*  credits":"User Blue Frog from https://stackoverflow.com/questions/50243769/vuetify-how-to-set-background-color*/"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }